import { OnSendDeleteConfirmation } from '~/features/events';
import { OptionType } from '~/features/types';
import { sendDeleteConfirmation } from '~/features/utils';
import { CERTIFICATION_CRUD_STATE, CONFIRMATION_VIEW_STATE } from '~/features/xstateSystem';
import { ISSUER_CERTS, ISSUER_OPTIONS } from './constants';
import { OnCertNameSelect, OnSendSharedContextEvent } from './events';
import { CertContext, CertScope } from './types';

export const sendLoadToCrud = ({ context }: { context: CertContext }) => {
  context.crudRef.send({ type: 'ON_LOAD' });
};

export const sendContextToCrud = ({ context }: { context: CertContext }) => {
  context.crudRef.send({
    type: 'ON_SEND_SHARED_CONTEXT',
    values: { providerId: context.providerId },
  });
};

export const setProviderData = (scope: CertScope): Partial<CertContext> => {
  const { values } = scope.event as OnSendSharedContextEvent;
  return {
    providerId: values.providerId,
    providerCategoryId: values.providerCategoryId,
  };
};

/**
 * Sets the issuer based on the Cert Name
 * If its custom, shows entire ISSUERS array in Constants
 * @param scope
 * @returns
 */
export const setIssuersOption = (scope: CertScope): Partial<CertContext> => {
  const event = scope.event as OnCertNameSelect;
  const options: OptionType[] = [];
  ISSUER_CERTS.forEach((obj) => {
    if (obj.certificates.includes(event.value)) {
      options.push({ label: obj.issuer, value: obj.issuer });
    }
  });
  if (options.length == 0) {
    return {
      issuerOptions: ISSUER_OPTIONS,
    };
  } else {
    return {
      issuerOptions: options,
    };
  }
};

export const openConfirmation = (scope: CertScope) => {
  const event = scope.event as OnSendDeleteConfirmation;

  const onConfirm = (id: number) => {
    scope.system.get(CERTIFICATION_CRUD_STATE).send({ type: 'ON_DELETE', payload: { id } });
  };
  scope.system
    .get(CONFIRMATION_VIEW_STATE)
    .send(sendDeleteConfirmation(() => onConfirm(event.payload.id)));
};
